import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import PropTypes from "prop-types";
import { Icon } from "@2solve/tosolve-icons";
import * as Icons from "@2solve/tosolve-icons/dist/icons";
const NavigationTabs = ({ tabs }) => {
  const location = useLocation();
  return (
    <Nav variant="underline" className="tab">
      {tabs.map((tab, index) => (
        <Nav.Item key={index}>
          <Link
            to={tab.path}
            className={`rota nav-link d-flex align-items-center ${
              location.pathname === tab.path ? "active" : ""
            }`}
          >
            <Icon
              color={"#004196"}
              height={35}
              width={35}
              icon={Icons[tab.iconName]}
            />
            {tab.name}
          </Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
NavigationTabs.propTypes = {
  tabs: PropTypes.array,
};
export default NavigationTabs;
